/**
 * @generated SignedSource<<e0bce87dda79aeae821126e9b9f97da2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CommentThreadAccessType = "EVERYONE" | "INDIVIDUALS";
export type CreateOrUpdateCommentMutationInput = {
  accessType?: CommentThreadAccessType | null;
  clientMutationId?: string | null;
  id?: string | null;
  json?: string | null;
  key: string;
  text: string;
  thread?: string | null;
  userIds?: ReadonlyArray<string | null> | null;
};
export type CommentsPanelCreateOrUpdateCommentMutation$variables = {
  input: CreateOrUpdateCommentMutationInput;
};
export type CommentsPanelCreateOrUpdateCommentMutation$data = {
  readonly Comment_CreateOrUpdate: {
    readonly errors: ReadonlyArray<{
      readonly field: string;
      readonly messages: ReadonlyArray<string>;
    } | null> | null;
    readonly id: string | null;
    readonly text: string | null;
    readonly thread: string | null;
  } | null;
};
export type CommentsPanelCreateOrUpdateCommentMutation = {
  response: CommentsPanelCreateOrUpdateCommentMutation$data;
  variables: CommentsPanelCreateOrUpdateCommentMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateOrUpdateCommentMutationPayload",
    "kind": "LinkedField",
    "name": "Comment_CreateOrUpdate",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "thread",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "text",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ErrorType",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "field",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "messages",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CommentsPanelCreateOrUpdateCommentMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CommentsPanelCreateOrUpdateCommentMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "6bde15da78e3625dfe642757af96e3ec",
    "id": null,
    "metadata": {},
    "name": "CommentsPanelCreateOrUpdateCommentMutation",
    "operationKind": "mutation",
    "text": "mutation CommentsPanelCreateOrUpdateCommentMutation(\n  $input: CreateOrUpdateCommentMutationInput!\n) {\n  Comment_CreateOrUpdate(input: $input) {\n    id\n    thread\n    text\n    errors {\n      field\n      messages\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "3eb197d4cd8057b426379ec2bb9f0a25";

export default node;
